export default class Buttons {
	static init() {
		this.buttons = document.querySelectorAll(".btn, .btn-fill, .btn-stroke, .btn-light");

		this.buttons.forEach( (button) => {

			const text = `<span class="btn-inner"><span class='label'>${button.innerHTML}</span></span>`;
			button.innerHTML = text;

			if( button.classList.contains('btn-go') || button.classList.contains('btn-back') ){
				const element = document.createElement("span");
				element.innerHTML = `<svg width="9" height="11" viewBox="0 0 9 11" xmlns="http://www.w3.org/2000/svg">
<path d="M4.37114e-07 5.5C3.96337e-07 5.96643 0.378118 6.34455 0.84455 6.34455L5.79056 6.34455L3.40505 8.71526C3.0865 9.03184 3.07684 9.54415 3.38324 9.87252C3.70358 10.2158 4.24444 10.226 4.5775 9.89503L9 5.5L4.5775 1.10497C4.24444 0.773979 3.70359 0.784175 3.38324 1.12748C3.07684 1.45585 3.0865 1.96816 3.40505 2.28474L5.79056 4.65545L0.84455 4.65545C0.378118 4.65545 4.77891e-07 5.03357 4.37114e-07 5.5Z"/>
</svg>`;
				element.classList.add('svg');
				button.querySelector('.btn-inner').appendChild(element);
			}


			if( button.classList.contains('btn-lang') ){
				const element = document.createElement("span");
				element.innerHTML = `<svg width="15" height="10" viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.08786 0.982932L8.15892 8.054L7.07107 9.14186L0 2.07079L1.08786 0.982932Z" fill="#34847A"/>
<path d="M14.1422 2.07077L7.07107 9.14186L5.98332 8.05398L13.0544 0.98291L14.1422 2.07077Z" fill="#34847A"/>
</svg>`;
				element.classList.add('svg');
				button.appendChild(element);
			}

		});

	}

}
